/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLineAxisX: {
  name: 'line-axis-x';
  data: string;
} = {
  name: 'line-axis-x',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.744 5.668a1 1 0 0 0-1.488-1.336l-4.74 5.282-2.926-2.445a2 2 0 0 0-2.565 0L4.36 10.233a1 1 0 1 0 1.282 1.534l3.667-3.064 2.925 2.445a2 2 0 0 0 2.771-.198l4.74-5.282ZM4 18a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2H4Z" fill="currentColor"/></svg>`,
};
